import { ExpandOutlined, MoonOutlined, SunOutlined } from '@ant-design/icons';
import {
  Avatar, Button, Layout, Popover,
} from 'antd';
import screenfull from 'screenfull';
import { useSelector } from 'react-redux';
import { useContext } from 'react';
import style from './index.module.scss';
import { RootState } from '../../../services/reduxStore';
import UserPopover from './components/UserPopover';
import { ThemeContext } from '../..';

const {
  wrapper, avatar, title, userZone,
} = style;
const { Header: AntdHeader } = Layout;

// eslint-disable-next-line no-underscore-dangle
const offlineModeEnabled = (window as any)._env_.REACT_APP_OFFLINE_MODE === 'true';

function Header() {
  const user = useSelector(({ auth }: RootState) => auth.user?.name);
  const { theme, setTheme } = useContext(ThemeContext);
  const goFullScreen = () => {
    if (screenfull.isEnabled && !screenfull.isFullscreen) return screenfull.request();
    return screenfull.exit();
  };
  return (
    <AntdHeader className={wrapper}>
      <div className={title}>
        <img src={`${process.env.PUBLIC_URL}/MetConsole_logo${theme === 'dark' ? '_dark' : ''}.png`} alt="logo MetConsole" />
        <span>Geographical Information Display</span>
      </div>
      {!offlineModeEnabled && (
      <div className={userZone}>
        <Button
          type="text"
          shape="circle"
          size="large"
          icon={theme === 'light' ? <MoonOutlined /> : <SunOutlined />}
          onClick={() => { setTheme(theme === 'light' ? 'dark' : 'light'); }}
        />
        <Button
          type="text"
          shape="circle"
          size="large"
          icon={<ExpandOutlined />}
          onClick={goFullScreen}
        />
        <Popover content={UserPopover} placement="bottomRight">
          <Avatar className={avatar} size="large">
            {user?.[0] ?? 'U'}
          </Avatar>
        </Popover>
      </div>
      )}
    </AntdHeader>
  );
}

export default Header;
